import React, { useEffect, useState } from "react";
import { IoWarning } from "react-icons/io5";
import { LuArrowRight, LuCalendarDays, LuTag, LuUserRound } from "react-icons/lu";
import { Link } from "react-router-dom";
import "../../css/items.scss";
import { serverInstance } from "../../service/axios";
import Dimmer from "../shared/Dimmer";
import './training-list.scss';

const TrainingList = ({ data }) => {
  const categories = ["Эрдмийн чуулганы лекц", "Цахим хичээл"]
  const [searchText, setSearchText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [years, setYears] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9);
  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate total pages
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // Change page
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    serverInstance.get("/app/trainings")
      .then(res => {
        res.data.items.sort((a, b) => b.year - a.year);
        let data = res.data.items
        data.map(item => item.fileUrl2 = item.fileUrl2 ? `https://msid-asset.s3.ap-northeast-2.amazonaws.com/${item.fileUrl2}` : '/images/background.png')
        setAllItems(data)
        setFilteredData(data)
        setErrorMsg("");
        setLoading(false);
        // Get unique years from data
        const years = Array.from(new Set(res.data.items?.map((item) => item.year))).sort();
        setYears(years)
      })
      .catch((err) => {
        setErrorMsg(err);
        setLoading(false);
      })

    window.scrollTo(0, 0);
  }, []);

  const getPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= 5) {
      // Show all pages if total is 5 or less
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Show limited pages with ellipsis
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        pageNumbers.push(1);
        pageNumbers.push('...');
        pageNumbers.push(currentPage - 1);
        pageNumbers.push(currentPage);
        pageNumbers.push(currentPage + 1);
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    return pageNumbers;
  };

  
  useEffect(() => {
    let result = allItems;

    // Text search filter
    if (searchText) {
      result = allItems.filter(
        (item) =>
          item.title?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.authors?.some((author) =>
            author.toLowerCase().includes(searchText.toLowerCase())
          )
      );
    }

    // Category filter
    if (selectedCategory) {
      result = result.filter((item) => item.category === selectedCategory);
    }

    // Year filter
    if (selectedYear) {
      result = result.filter((item) => String(item.year) === String(selectedYear));
    }

    setFilteredData(result);
    setCurrentPage(1);

  }, [allItems, searchText, selectedYear, selectedCategory]);

  return (
    <div id="trainings" className='items-container'>
      
      {loading ? <Dimmer /> : null}

      <section className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>
        </div>
      </section>

      {errorMsg ? <div className="error-msg">
        <IoWarning />
        &nbsp;
        {errorMsg}
      </div> : null}

      <div className='filters col-11'>
        <div className='filter-row'>
          <input
            type='text'
            placeholder={data.placeholder}
            className="search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />  
        </div>

        <div className='filter-row'>
          {/* <input
            type='text'
            placeholder={data.keyword}
            className="keyword-search"
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
          /> */}
          <select
            className="category-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}>
            <option value=''>{data.allCategory}</option>
            {categories.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>    
          <select
            className="year-select"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}>
            <option value=''>{data.allYears}</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>

      <section className='training-list col-11'>
        {!loading && filteredData.length > 0 ?
          currentItems.map((training) => {
            const detailPath = "/training/" + training.id;
            const authors = training.authors?.join(", ");

            return (
              <article key={training.id} className='training-item'>
                <Link className="training-img" to={detailPath} aria-label={training.title}>
                  <img src={training.fileUrl2} alt={training.title} />
                </Link>
                <div className="training-content">
                  <Link className="training-name" to={detailPath}>
                    {training.title}
                  </Link>
                  {training.description ? (
                    <div className='training-desc max-line-2'>
                      {training.description}
                    </div>
                  ) : null}
                  <div className='training-meta'>
                    {authors ? (
                      <div className='training-author'>
                        <LuUserRound aria-hidden="true" />
                        <span>{authors}</span>
                      </div>
                    ) : null}
                    {training.category ? (
                      <div className='training-category'>
                        <LuTag aria-hidden="true" />
                        <span>{training.category}</span>
                      </div>
                    ) : null}
                    {training.year ? (
                      <div className='training-year'>
                        <LuCalendarDays aria-hidden="true" />
                        <span>{training.year}</span>
                      </div>
                    ) : null}
                  </div>
                  <Link className="archive-card-link" to={detailPath}>
                    <span>{data.open}</span>
                    <LuArrowRight aria-hidden="true" />
                  </Link>
                </div>
              </article>
            );
          })
          :
          !loading ? (
            <div className='archive-empty-state'>
              {data.noDataFound}
            </div>
          ) : null
        }
      </section>

      {!loading && totalPages > 1 ? (
      <div className="pagination training-pagination d-flex justify-content-center flex-wrap">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="pagination-btn mx-1">
          {"<"}
        </button>

        {getPageNumbers().map((number, index) => (
          <button
            key={index}
            onClick={() => number !== '...' ? handlePageChange(number) : null}
            className={`pagination-btn mx-1 ${currentPage === number ? 'active' : ''} ${number === '...' ? 'dots' : ''}`}
          >
            {number}
          </button>
        ))}

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="pagination-btn mx-1">
          {">"}
        </button>
      </div>
      ) : null}
    </div>
  );
};

export default TrainingList;
